import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getPageTitle, getMetaDescription } from '../utils/pageTitle';
import { Heading, Text, Button, Center, VStack } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <>      <Helmet>
        <title>{getPageTitle("404 - Page Not Found")}</title>
        <meta name="description" content={getMetaDescription("The page you are looking for could not be found.")} />
      </Helmet>
      <Center minHeight="calc(100vh - 160px)" px={4}> {/* Adjust height based on Header/Footer */}
      <VStack spacing={4} textAlign="center">
        <Heading as="h1" size="2xl" color="red.500">
          404
        </Heading>
        <Heading as="h2" size="lg">
          Oops! Page Not Found
        </Heading>
        <Text fontSize="lg" color="gray.500">
          The page you are looking for does not seem to exist.
        </Text>
        <Button as={Link} to="/" colorScheme="blue" mt={6}>
          Go Back Home
        </Button>      </VStack>
    </Center>
    </>
  );
};

export default NotFoundPage;